// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"476f3c91","184":"cc580dea","259":"20530664","810":"394135f9","812":"a6f64a91","867":"6ee001df","961":"347fd5e2"}[chunkId] + ".chunk.js";
};